exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#layers-list .dropdown > .btn {\n  background: transparent;\n  border: none;\n  color: #007bff;\n  padding: 3px;\n  box-shadow: none;\n}\n#layers-container {\n  position: relative;\n}\n.layers-toolbar {\n  background-color: #fff;\n  -webkit-flex: none;\n  flex: none;\n}\n.layers-toolbar .btn {\n  z-index: 10;\n}\n.layers-toolbar * {\n  border-radius: 0 !important;\n}\n.layers-toolbar .btn {\n  z-index: 10;\n}\n#download-tool {\n  margin-left: auto;\n}\n.version-info {\n  line-height: 40px;\n  margin: auto;\n}\n.layers-loading {\n  position: sticky;\n  position: -webkit-sticky;\n  bottom: 0;\n  left: 50%;\n}\n", ""]);

// exports
